export default __webpack_public_path__ + "static/media/ipath.25eb2fc9.png";